// @ts-expect-error: api-client is imported for embed flow only
import AxiosService from '@deltax/api-client'

import appConfig from '@/constants/appConfig'

/**
 * Legacy API client retained for embed authentication until embed flow is migrated to IdP.
 */
class EmbedApiClient {
  readonly apiMethods: {
    loginWithEmbedToken: (
      clientToken: string,
      userId: string,
      brandId?: string,
    ) => Promise<unknown>
    logout: () => Promise<unknown>
  }

  constructor(baseUrl: string) {
    const axiosService = new AxiosService(
      baseUrl,
      appConfig.STUNNR_BE_CLIENT_ID,
      import.meta.env.DEV ? 'be.stunnr.co' : window.location.hostname,
      (error: unknown) => Promise.reject(error),
    )
    this.apiMethods = axiosService.getApiMethods()
  }
}

export default EmbedApiClient
